import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./releaseDetail.css";
import logo from "../../../img/Conga_Wordmark_Purple400Small.svg";
import Accordion from "@salesforce/design-system-react/components/accordion";
import AccordionPanel from "@salesforce/design-system-react/components/accordion/panel";
import IconSettings from "@salesforce/design-system-react/components/icon-settings";
import Spinner from "@salesforce/design-system-react/components/spinner";
import DataTable from "@salesforce/design-system-react/components/data-table";
import DataTableColumn from "@salesforce/design-system-react/components/data-table/column";
import DataTableCell from "@salesforce/design-system-react/components/data-table/cell";
import { getApiBaseURL } from "../../common";
import Checkbox from "@salesforce/design-system-react/components/checkbox";
import Icon from "@salesforce/design-system-react/components/icon";
import { PU_RELEATIVE_PATH, SF_ICON_PATH } from "../../../config";

import {
  doLogout,
  logout,
  isLoggedIn,
  isEmpty,
  getOrgId,
  getAccessToken,
  checkIsPacakageNew,
  handleAPIErrors,
} from "../../common";
import api from "../../../api";

const TableCellWithDocLink = ({ children, ...props }) => (
  <DataTableCell {...props}>
    {isEmpty(props.item["targetDocumentationUrl"]) ? (
      children
    ) : (
      <a
        href="#"
        onClick={(event) => {
          window.open(props.item["targetDocumentationUrl"]);
        }}
      >
        {children}
      </a>
    )}
  </DataTableCell>
);

const TableCellWithReleaseName = ({ children, ...props }) => (
  <DataTableCell {...props}>
    {props.item["installedPatchName"] ? (
      children + " - " + props.item["installedPatchName"]
    ) : isEmpty(children) ? (
      <span>-</span>
    ) : (
      children
    )}
  </DataTableCell>
);

const TableCellWithPackage = ({ children, ...props }) => (
  <DataTableCell {...props}>
    {checkIsPacakageNew(children, props.item["status"])}
  </DataTableCell>
);

const TableCellWithVersionFrmt = ({ children, ...props }) => (
  <DataTableCell {...props}>
    {isEmpty(children) ? <span>-</span> : children}
  </DataTableCell>
);

const columns = [
  <DataTableColumn
    key="packageName"
    label="Package Name"
    property="packageName"
    width="25%"
  >
    <TableCellWithPackage />
  </DataTableColumn>,

  <DataTableColumn
    key="installedVersion"
    label="Installed Version"
    property="installedVersion"
    width="25%"
  >
    <TableCellWithVersionFrmt />
  </DataTableColumn>,

  <DataTableColumn
    key="installedReleaseName"
    label="Installed Release - {Patch}"
    property="installedReleaseName"
    width="25%"
  >
    <TableCellWithReleaseName />
  </DataTableColumn>,

  <DataTableColumn
    key="targetVersion"
    label="Latest Certified Version"
    property="targetVersion"
    width="25%"
  >
    <TableCellWithDocLink />
  </DataTableColumn>,
];

TableCellWithDocLink.displayName = DataTableCell.displayName;
TableCellWithReleaseName.displayName = DataTableCell.displayName;
TableCellWithPackage.displayName = DataTableCell.displayName;
TableCellWithVersionFrmt.displayName = DataTableCell.displayName;

class ReleaseDetail extends PureComponent<{}, any> {
  constructor(props) {
    super(props);
    this.state = {
      expandedPanels: [],
      organization: {},
      isLoading: true,
      expandAllAccordian: false,
    };
  }

  async componentDidMount() {
    // return false;
    // document.getElementById('myAmy')
    try {
      this.getInitData();
    } catch (e) {
      console.log("some error", e, e.message);
    }
  }

  //Using Auth Code authenticate the connected app to get access token.
  getOrgReleaseInformation(orgId) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
    };

    api.get(
      getApiBaseURL() +
      "/CustomerPreference/GetSubscriberReleaseDetail/" +
      orgId +
      "/true",
      requestOptions
    )
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        this.setState({ organization: response });
        let expandedAccordian = [];
        if (!isEmpty(response.products)) {
          response.products.map((item) => {
            expandedAccordian[item.productName] = false;
          });
        }
        this.setState({ isLoading: false });
        this.setState({ expandedPanels: expandedAccordian });
      });
  }

  //Redirect to registration form page by passing the Organization ID.
  redirectToRegistrationPageWithOrgId(orgId) {
    window.location.href = PU_RELEATIVE_PATH + "consent-form";
  }

  getInitData = async () => {
    let orgID = getOrgId();

    if (!isEmpty(orgID) && isLoggedIn()) {
      this.getOrgReleaseInformation(orgID);
    } else {
      console.log("Log out");
      doLogout();
      window.location.href = PU_RELEATIVE_PATH + "welcome";
    }
  };

  togglePanel(event, data) {
    var destinationObject = Object.assign(this.state.expandedPanels);
    destinationObject[data.productName] = !destinationObject[data.productName];
    this.setState({ expandedPanels: destinationObject });
    let toggleBtnChecker = arr => Object.values(destinationObject).every(item => item === true)
    if (toggleBtnChecker(destinationObject)) {
      this.setState({ expandAllAccordian: true });
    }
    else {
      this.setState({ expandAllAccordian: false });
    }
    this.forceUpdate();
  }

  /* Method to Expand/Collapse all the accordian at once */
  onToggleAllAccordian() {
    var destinationObject = Object.assign(this.state.expandedPanels);
    this.state.organization.products.forEach((element) => {
      destinationObject[element.productName] = !this.state.expandAllAccordian;
    });
    this.setState({ expandedPanels: destinationObject });
    this.setState({ expandAllAccordian: !this.state.expandAllAccordian });
    this.forceUpdate();
  }

  render() {
    return (
      <div class="releaseInfo-background-theme .img-fluid">
        {this.state.isLoading && (
          <Spinner
            size="large"
            variant="brand"
            assistiveText={{ label: "Loading..." }}
          />
        )}
        <div class="slds-context-bar">
          <div class="slds-context-bar__primary">
            <div class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
              <div class="slds-context-bar__icon-action">
                <img class="img" width="30" alt="Conga Logo" src={logo} />
              </div>
              <span class="slds-context-bar__label-action slds-context-bar__app-name">
                <span class="slds-truncate" title="Conga Upgrade">
                  Conga Upgrade
                </span>
              </span>
            </div>
          </div>
          <nav class="slds-context-bar__secondary" role="navigation">
            <ul class="slds-grid">
              <li
                class="slds-context-bar__item"
                routerLinkActive="slds-is-active"
              >
                <a
                  href={PU_RELEATIVE_PATH + "consent-form"}
                  class="slds-context-bar__label-action"
                  title="Registration"
                >
                  <span class="slds-truncate" title="Org Registration Form">
                    Org Registration Form
                  </span>
                </a>
              </li>
              <li
                class="slds-context-bar__item slds-is-active"
                routerLinkActive="slds-is-active"
              >
                <a
                  class="slds-context-bar__label-action"
                  title="Release Detail"
                >
                  <span class="slds-truncate" title="Release Details">
                    Installed Release Details
                  </span>
                </a>
              </li>
            </ul>
          </nav>
          <a class="logout-icon" onClick={logout}>
            <span title="Log Out">
              <IconSettings iconPath={SF_ICON_PATH}>
                <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
                  <div className="slds-col_padded">
                    <Icon
                      assistiveText={{ label: "Account" }}
                      category="utility"
                      name="logout"
                      size="small"
                    />
                  </div>
                </div>
              </IconSettings>
            </span>
          </a>
        </div>

        {!this.state.isLoading && (
          <div class="row reg-form slds-text-body_regular">
            <div class="col-md-12 release-detail border-10">
              <h2>Release Details</h2>
              <hr class="solid"></hr>
              {this.state.organization.isOrgUpgraded && (
                <h3 class="upgrade-alert">{this.state.organization.comment}</h3>
              )}

              <div class="d-flex">
                <div class="mr-auto p-2">
                  <h3>
                    Latest Certified Release -{" "}
                    {this.state.organization.shortReleaseName} (Release Notes
                    are{" "}
                    <a
                      href="#"
                      onClick={(event) => {
                        window.open(this.state.organization.mainDocumentUrl);
                      }}
                    >
                      here
                    </a>
                    )
                  </h3>
                </div>
                {!isEmpty(this.state.organization.products) && (
                  <div class="p-2">
                    <Checkbox
                      labels={{
                        label: "Expand All Products",
                        toggleEnabled: "Close All",
                        toggleDisabled: "Open All",
                      }}
                      size="large"
                      id="checkbox-toggle-example1"
                      name="expand-all"
                      variant="toggle"
                      onChange={this.onToggleAllAccordian.bind(this)}
                      checked={this.state.expandAllAccordian}
                    />
                  </div>
                )}
              </div>

              <IconSettings iconPath={SF_ICON_PATH}>
                <div>
                  <Accordion id="base-example-accordion" className="acc-prd">
                    {this.state.organization.products &&
                      this.state.organization.products.map((item, i) => {
                        return (
                          <AccordionPanel
                            expanded={
                              this.state.expandedPanels[item.productName]
                            }
                            id={item.productName}
                            key={item.productName}
                            onTogglePanel={(event) =>
                              this.togglePanel(event, item)
                            }
                            summary={item.productName}
                          >
                            <div>
                              <DataTable
                                items={item.packages}
                                id="DataTableExample-1-default"
                                className="release-table table"
                              >
                                {columns}
                              </DataTable>
                            </div>
                          </AccordionPanel>
                        );
                      })}
                  </Accordion>
                </div>
              </IconSettings>

              <hr class="solid" />
              {isEmpty(this.state.organization.products) ? (
                <div class="release-disclaimer">
                  <p>{this.state.organization.comment}</p>
                  <br />
                </div>
              ) : (
                <div class="release-disclaimer">
                  <h2>Notes</h2>
                  <div>
                    Packages with (*) are dependent packages which needs to be
                    installed to ensure the core features to work as expected
                    <br />
                    <br /> The packages marked as (New) are new packages in this
                    release.
                    <br />
                    <br /> All the mandatory related/dependent pacakges will be
                    installed for Example - Along with Conga Contract Managment
                    package for CLM - Conga Base Library will be installed
                    <br />
                    <br /> This package may send or release data from
                    third-party websites. Make sure you trust these websites -
                    <br /> CSP Trusted Site
                    <br />
                  </div>
                  <ul>
                    <li>https://content.analytics.apttus.com</li>
                    <li>https://data.analytics.apttus.com</li>
                    <li>Website - data.analytics.apttus.com(SSL Encrypted)</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReleaseDetail));
